import React from 'react';
import Img from 'gatsby-image';
import style from '../cssmodules/team.module.scss';

function Team({ members }) {
  return (
    <div className={style.wrapper}>
      <h2 className={`heading2 ${style.title}`}>Leadership Team</h2>
      <ul className={style.team}>
        {members.map(member => (
          <li className={style.member} key={member.name}>
            <Img
              className={style.profile}
              sizes={{
                ...member.portrait.childImageSharp.fluid,
                aspectRatio: 1 / 1,
              }}
            />
            <div className={style.details}>
              <h2 className={style.name}>{member.name}</h2>
              <p className={style.role}>{member.jobtitle}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Team;
